module.exports = __webpack_public_path__ + "img/Stok.4de63cbc.svg";